import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Severity } from '@app/exceptions/services/notify.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
    public iconsByAlertType: any = {
        warning: 'warning',
        success: 'check_circle',
        info: 'info',
        error: 'error'
    };
    @Input() public alertType: Severity = 'info';
    @Input() public showIcon: boolean = true;
}
